import { createStore } from 'vuex'
import { getField, updateField } from "vuex-map-fields";
import clientConfig from '../config/client';
import premiumVariables from '../config/premiumVariables';


// -----------------------------------------------------

const state = {
  debugMode: true,
  activeTab: 1,

  data: clientConfig.insurancePremiumData,

  age: clientConfig.defaults.age,
  annualIncome: clientConfig.defaults.annualIncome,
  gender: clientConfig.defaults.gender,
  coverAmount: clientConfig.defaults.coverAmount,
  benefitPeriod: clientConfig.defaults.benefitPeriod,
  waitingPeriod: clientConfig.defaults.waitingPeriod,

  protectionBenefits: null,
  superBenefits: null,
  unitsOfCover: null,
  costPerPeriod: null,
  costPerYear: null,

  premiumVariables: premiumVariables,
};

// -----------------------------------------------------

const mutations = {

  premiumVariables(state, value) {
    state.premiumVariables = value;
  },

  setActiveTab(state, value) {
    state.activeTab = value;
  },

  updateAge(state, value) {
    state.age = value;
  },

  updateAnnualIncome(state, value) {
    state.annualIncome = value;
  },

  updateGender(state, value) {
    state.gender = value;
  },

  updateCoverAmount(state, value) {
    state.coverAmount = value;
  },

  updateBenefitPeriod(state, value) {
    state.benefitPeriod = value;
  },

  updateWaitingPeriod(state, value) {
    state.waitingPeriod = value;
  },

  updateProtectionBenefits(state, value) {
    state.protectionBenefits = value;
  },

  updateSuperBenefits(state, value) {
    state.superBenefits = value;
  },

  updateUnitsOfCover(state, value) {
    state.unitsOfCover = value;
  },

  updateCostPerPeriod(state, value) {
    state.costPerPeriod = value;
  },
  
  updateCostPerYear(state, value) {
    state.costPerYear = value;
  },

  updateField
};

// -----------------------------------------------------

const getters = {
  debugMode: state => {
    return state.debugMode;
  },

  updateTriggered: state => {
    return state;
  },

  activeTab: state => {
    return state.activeTab;
  },

  data: state => {
    return state.data;
  },

  getField
};

export default createStore({
  state,
  mutations,
  getters
});